import React, { useState, useEffect } from 'react';
import festivalsData from './festivals.json';
import './Festivals.css';

function FestivalsApp() {
  const [selectedFestivalId, setSelectedFestivalId] = useState('');
  const [festival, setFestival] = useState(null);

  useEffect(() => {
    const loadVoices = () => {
      const voices = window.speechSynthesis.getVoices();
      if (voices.length === 0) {
        setTimeout(loadVoices, 100);
      }
    };
    loadVoices();
  }, []);

  const speak = (text, langCode) => {
    const synth = window.speechSynthesis;
    const voices = synth.getVoices();
    const voice = voices.find(v => v.lang === langCode);
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = langCode;
    if (voice) utterance.voice = voice;
    synth.speak(utterance);
  };

  const allFestivals = Array.isArray(festivalsData)
    ? festivalsData
    : festivalsData.flatMap(group => group.festivals || []);

  useEffect(() => {
    const selected = allFestivals.find(f => f.id === selectedFestivalId);
    setFestival(selected || null);
  }, [selectedFestivalId, allFestivals]);

  return (
    <div className="app">
      <h1>🎉 Festivals in India</h1>

      <select value={selectedFestivalId} onChange={e => setSelectedFestivalId(e.target.value)}>
        <option value="">Select Festival</option>
        {allFestivals.map(f => (
          <option key={f.id} value={f.id}>{f.name}</option>
        ))}
      </select>

      {festival && (
        <div className="festival-details">
          <h2>{festival.name}</h2>

          {/* English */}
          <div className="language-block">
            <h3>📘 In English</h3>
            {festival.details.english.lines.map((line, i) => <p key={i}>{line}</p>)}
            <button onClick={() => speak(festival.details.english.lines.join(' '), 'en-US')}>🔊 Read Aloud (English)</button>
          </div>

          {/* Telugu */}
          <div className="language-block">
            <h3>🌸 In Telugu</h3>
            {festival.details.telugu.lines.map((line, i) => <p key={i}>{line}</p>)}
            <button onClick={() => speak(festival.details.telugu.lines.join(' '), 'te-IN')}>🔊 Read Aloud (Telugu)</button>
          </div>

          {/* Hindi */}
          <div className="language-block">
            <h3>🌼 In Hindi</h3>
            {festival.details.hindi.lines.map((line, i) => <p key={i}>{line}</p>)}
            <button onClick={() => speak(festival.details.hindi.lines.join(' '), 'hi-IN')}>🔊 Read Aloud (Hindi)</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default FestivalsApp;
